import React, {useEffect, useState} from 'react';
import {
    Card,
    Tabs,
    Row,
    Col,
    Form,
    Input,
    Button,
    Avatar,
    Upload,
    Image,
    message
} from 'antd';
import {
    UserOutlined,
    CameraOutlined,
    LockOutlined,
    MailOutlined,
    PhoneOutlined, UsergroupAddOutlined
} from '@ant-design/icons';
import api, {instance} from "../services/api";
import apiService from "../services/api";
import roleUtil from "../utils/roleUtil";
import {encryptPassword} from "../utils/cryptoUtils";
import {Navigate, useNavigate} from "react-router-dom";
import {ImageUtils} from "../utils/ImageUtils";

// 密码强度组件
const PasswordStrengthMeter = ({password}) => {
    if (!password) return null;

    const getStrength = (pass) => {
        if (pass.length < 6) return 0;
        if (pass.length < 8) return 1;
        if (/[A-Z]/.test(pass)) return 3;
        if (/\d/.test(pass)) return 2;
        return 1;
    };

    const strength = getStrength(password);
    const strengthText = ['非常弱', '弱', '中等', '强'];
    const strengthColor = ['#ff4d4f', '#faad14', '#52c41a', '#389e0d'];

    return (
        <div style={{marginBottom: 16}}>
            <div style={{
                height: 6,
                backgroundColor: '#f0f0f0',
                marginBottom: 4
            }}>
                <div style={{
                    width: `${(strength + 1) * 25}%`,
                    height: '100%',
                    backgroundColor: strengthColor[strength]
                }}/>
            </div>
            <span style={{color: strengthColor[strength]}}>
        密码强度: {strengthText[strength]}
      </span>
        </div>
    );
};

// 头像组件
const UserAvatar = ({user, onUpdateAvatar}) => {
    const [loading, setLoading] = useState(false);

    const handleChange = async (info) => {
        if (info.file.status === 'uploading') {
            setLoading(true);
            return;
        }
        if (info.file.status === 'done') {
            // const res = await ImageUtils.getBase64(info.file.originFileObj)
            // console.log("base64编码数据", res)
            console.log("上传文件", info)
            const response = await api.user.uploadAvatar(info.file.originFileObj)
            if (response.code === 200) {
                onUpdateAvatar(apiService.baseURL + response.data);
                setLoading(false);
                message.success('头像上传成功');
            } else {
                message.error('头像上传失败');
            }
            // console.log("上传成功", info)
            // onUpdateAvatar(res);
            // setLoading(false);
            // message.success('头像上传成功');
        }
        if (info.file.status === 'error') {
            setLoading(false);
            message.error('头像上传失败');
        }
    };

    return (
        <div style={{textAlign: 'center'}}>
            <Upload
                name="avatar"
                showUploadList={false}
                action="/api/upload/avatar"
                onChange={handleChange}
                disabled={loading}
            >
                {user.avatar ? (
                    <Image
                        width={120}
                        height={120}
                        src={user.avatar}
                        key={user.avatar} // 强制刷新
                        preview={false}
                        style={{
                            borderRadius: '50%',
                            objectFit: 'cover',
                            cursor: 'pointer'
                        }}
                    />
                ) : (
                    <Avatar
                        size={120}
                        icon={<UserOutlined/>}
                        style={{cursor: 'pointer'}}
                    />
                )}
            </Upload>
            <div style={{marginTop: 16}}>
                <CameraOutlined/> 点击更换头像
            </div>
        </div>
    );
};

// 基本信息表单
const UserInfoForm = ({user, onUpdate}) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        form.setFieldsValue(user);
    }, [user]);

    const onFinish = async (values) => {
        console.log('提交更新:', values)
        setLoading(true);
        try {
            console.log("提交更新:", values)
            const res = await api.user.updateProfile(values)
            onUpdate({
                avatar : apiService.baseURL + res.data.avatar,
                nickName: res.data.nickname,
                phonenumber: res.data.phone,
                email: res.data.email,
                role: roleUtil.getRoleLabel(res.data.userType)
            })
            message.success('个人信息更新成功');
        } catch (error) {
            message.error('更新失败: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form
            form={form}
            initialValues={user}
            onFinish={onFinish}
            labelCol={{span: 6}}
            wrapperCol={{span: 14}}
        >
            <Form.Item
                label="用户昵称"
                name="nickName"
                rules={[{required: true, message: '请输入昵称'}]}
            >
                <Input/>
            </Form.Item>
            <Form.Item
                label="手机号码"
                name="phonenumber"
                rules={[
                    {required: true, message: '请输入手机号'},
                    {pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确'}
                ]}
            >
                <Input prefix={<PhoneOutlined/>}/>
            </Form.Item>
            <Form.Item
                label="邮箱"
                name="email"
                rules={[
                    {required: true, message: '请输入邮箱'},
                    {type: 'email', message: '邮箱格式不正确'}
                ]}
            >
                <Input prefix={<MailOutlined/>}/>
            </Form.Item>
            <Form.Item wrapperCol={{offset: 6, span: 14}}>
                <Button type="primary" htmlType="submit" loading={loading}>
                    保存修改
                </Button>
            </Form.Item>
        </Form>
    );
};

// 密码修改表单
// const ResetPasswordForm = () => {
//     const [form] = Form.useForm();
//     const [loading, setLoading] = useState(false);
//     const navigate = useNavigate();
//
//     const onFinish = async (values) => {
//         setLoading(true);
//         console.log("修改密码参数", values)
//         const changePasswordData = {
//             oldPassword: encryptPassword(values.oldPassword),
//             newPassword: encryptPassword(values.newPassword),
//             confirmPassword: encryptPassword(values.confirmPassword)
//         }
//         console.log("修改密码加密参数", changePasswordData)
//         try {
//             // 这里替换为实际的API调用
//             const res = await apiService.user.changePassword(changePasswordData)
//             if (res && res.code === 200) {
//                 message.success('密码修改成功,请重新登录');
//                 // 清理token
//                 localStorage.removeItem('token');
//                 navigate("/login")
//             } else {
//                 message.error('密码修改失败')
//             }
//         } catch (error) {
//             message.error('密码修改失败: ' + error.message);
//         } finally {
//             setLoading(false);
//         }
//     };
//
//     return (
//         <Form
//             form={form}
//             onFinish={onFinish}
//             labelCol={{span: 6}}
//             wrapperCol={{span: 14}}
//         >
//             <Form.Item
//                 label="旧密码"
//                 name="oldPassword"
//                 rules={[{required: true, message: '请输入旧密码'}]}
//             >
//                 <Input.Password prefix={<LockOutlined/>}/>
//             </Form.Item>
//             <Form.Item
//                 label="新密码"
//                 name="newPassword"
//                 rules={[
//                     {required: true, message: '请输入新密码'},
//                     {min: 6, message: '密码至少6位字符'}
//                 ]}
//             >
//                 <Input.Password prefix={<LockOutlined/>}/>
//             </Form.Item>
//             <Form.Item shouldUpdate>
//                 {() => (
//                     <PasswordStrengthMeter
//                         password={form.getFieldValue('newPassword')}
//                     />
//                 )}
//             </Form.Item>
//             <Form.Item
//                 label="确认密码"
//                 name="confirmPassword"
//                 dependencies={['newPassword']}
//                 rules={[
//                     {required: true, message: '请确认密码'},
//                     ({getFieldValue}) => ({
//                         validator(_, value) {
//                             if (!value || getFieldValue('newPassword') === value) {
//                                 return Promise.resolve();
//                             }
//                             return Promise.reject('两次输入的密码不一致');
//                         },
//                     }),
//                 ]}
//             >
//                 <Input.Password prefix={<LockOutlined/>}/>
//             </Form.Item>
//             <Form.Item wrapperCol={{offset: 6, span: 14}}>
//                 <Button type="primary" htmlType="submit" loading={loading}>
//                     提交修改
//                 </Button>
//             </Form.Item>
//         </Form>
//     );
// };

// 主页面
const ProfilePage = () => {
    const [user, setUser] = useState({
        // avatar: 'https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png',
        // nickName: '张三',
        // phonenumber: '13800138000',
        // email: 'user@example.com',
        // role : '管理员'
    });

    useEffect(() => {
        getUser()
    }, []);

    const getUser = async () => {
        // 这里替换为实际的API调用
        const res = await apiService.user.getInfo();
        setUser({
            avatar: apiService.baseURL + res.data.avatar,
            nickName: res.data.nickname,
            phonenumber: res.data.phone,
            email: res.data.email,
            role: roleUtil.getRoleLabel(res.data.role)
        })
        // console.log(user)
    };

    const handleUpdateUser = async (values) => {
        // setUser({ ...user, ...values });
        setUser({...values})
        console.log(user)
    };

    const handleUpdateAvatar = (avatarUrl) => {
        console.log(avatarUrl)
        setUser({...user, avatar: avatarUrl});
    };

    return (
        <div className="app-container" style={{padding: 24}}>
            <Row gutter={[16, 16]}>
                <Col xs={24} md={8}>
                    <Card title="个人信息" bordered={false}>
                        <UserAvatar user={user} onUpdateAvatar={handleUpdateAvatar}/>
                        <div style={{marginTop: 24}}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: 8
                            }}>
                                <UserOutlined style={{marginRight: 8}}/>
                                <span>{user.nickName}</span>
                            </div>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: 8
                            }}>
                                <PhoneOutlined style={{marginRight: 8}}/>
                                <span>{user.phonenumber}</span>
                            </div>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: 8
                            }}>
                                <MailOutlined style={{marginRight: 8}}/>
                                <span>{user.email}</span>
                            </div>

                            <div style={{}}>
                                <UsergroupAddOutlined style={{marginRight: 8}}/>
                                <span>{user.role}</span>
                            </div>
                        </div>
                    </Card>
                </Col>
                <Col xs={24} md={16}>
                    <Card bordered={false}>
                        <Tabs defaultActiveKey="1">
                            <Tabs.TabPane tab="基本资料" key="1">
                                <UserInfoForm user={user} onUpdate={handleUpdateUser}/>
                            </Tabs.TabPane>
                            {/*<Tabs.TabPane tab="修改密码" key="2">*/}
                            {/*    <ResetPasswordForm/>*/}
                            {/*</Tabs.TabPane>*/}
                        </Tabs>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default ProfilePage;